module.exports = __webpack_public_path__ + "img/Relationship.b923287a.svg";